import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewSolicitacaoModal from '../Solicitacoes/ViewSolicitacaoModalADM';
import api from '../../../services/api';
import '../../Prefeitura/Home/Home.css';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import API_CONFIG from '../../../config/api.config';

const Cotacao = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { idPrefeitura, idSolicitacao, nomePrefeitura } = location.state || {};

  // Debug: mostrar ids recebidos
  //console.log('DEBUG idPrefeitura:', idPrefeitura, 'idSolicitacao:', idSolicitacao);

  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedSolicitacao, setSelectedSolicitacao] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cotacoes, setCotacoes] = useState([]);
  const [cotacoesPaginacao, setCotacoesPaginacao] = useState(null);
  const solicitacoesPerPage = 8;
  const [selectedFornecedor, setSelectedFornecedor] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [loading, setLoading] = useState(false);

  // Buscar cotações dos fornecedores para a solicitação
  const buscarCotacoes = async (pagina = 1) => {
    if (!idSolicitacao) return;
    try {
      setLoading(true);
      const params = { page: pagina, per_page: solicitacoesPerPage };
      if (dataInicio) params.data_inicio = dataInicio;
      if (dataFim) params.data_fim = dataFim;
      const response = await api.get(API_CONFIG.ENDPOINTS.COTACOES.LISTAR_COTACAO_FORNECEDORES(idSolicitacao), { params });
      if (response.data.status && response.data.cotacoes) {
        setCotacoesPaginacao(response.data.cotacoes);
        setCotacoes(response.data.cotacoes.data);
        setCurrentPage(response.data.cotacoes.current_page);
      } else {
        setCotacoes([]);
        setCotacoesPaginacao(null);
      }
    } catch (error) {
      setCotacoes([]);
      setCotacoesPaginacao(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarCotacoes(1);
    // eslint-disable-next-line
  }, [idSolicitacao, dataInicio, dataFim]);

  // Filtro por fornecedor (local, pois a API não tem filtro por fornecedor)
  const cotacoesFiltradas = selectedFornecedor
    ? cotacoes.filter(c => c.COT_FOR_ID === selectedFornecedor)
    : cotacoes;

  const totalPages = cotacoesPaginacao?.last_page || 1;
  const nextPage = () => {
    if (cotacoesPaginacao?.next_page_url) {
      const url = new URL(cotacoesPaginacao.next_page_url);
      const page = url.searchParams.get('page');
      buscarCotacoes(Number(page));
    }
  };
  const prevPage = () => {
    if (cotacoesPaginacao?.prev_page_url) {
      const url = new URL(cotacoesPaginacao.prev_page_url);
      const page = url.searchParams.get('page');
      buscarCotacoes(Number(page));
    }
  };

  const handleViewSolicitacao = (solicitacao) => {
    setSelectedSolicitacao(solicitacao);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSolicitacao(null);
    buscarCotacoes(cotacoesPaginacao?.current_page || 1);
  };

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title" style={{ marginBottom: 20 }}>Cotações dos Fornecedores</h1>
        <div className="modal-content">
          <div className="search-container" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              style={{ minWidth: 220, maxWidth: 320, width: 320, marginBottom: 8 }}
            >
              <InputLabel id="select-fornecedor-label">Selecione o Fornecedor</InputLabel>
              <Select
                labelId="select-fornecedor-label"
                value={selectedFornecedor}
                label="Selecione o Fornecedor"
                onChange={e => setSelectedFornecedor(e.target.value)}
              >
                <MenuItem value="">
                  <em>Todos</em>
                </MenuItem>
                {cotacoes
                  .map((c) => ({ id: c.COT_FOR_ID, nome: `Fornecedor #${c.COT_FOR_ID}` }))
                  .filter((v, i, a) => a.findIndex(t => t.id === v.id) === i)
                  .map((f) => (
                    <MenuItem key={f.id} value={f.id}>{f.nome}</MenuItem>
                  ))}
              </Select>
            </FormControl>

            <TextField
              label="Data Início"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
              inputProps={{ max: dataFim }}
              style={{ minWidth: 150, marginBottom: 8 }}
            />
            <TextField
              label="Data Fim"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
              inputProps={{ min: dataInicio }}
              style={{ minWidth: 150, marginBottom: 8 }}
            />
            <button
              className="search-button"
              onClick={() => buscarCotacoes(1)}
              style={{ height: 40, marginLeft: 4, marginBottom: 8 }}
            >
              PROCURAR
            </button>
          </div>
          <div className="cards-grid">
            {loading ? (
              <div className="no-results">Carregando...</div>
            ) : cotacoesFiltradas.length > 0 ? (
              cotacoesFiltradas.map((cotacao) => (
                <div key={cotacao.COT_ID} className="card">
                  <h2 className="card-title">Cotação #{cotacao.COT_ID}</h2>
                  <div className="card-content">
                    <div className="card-info"><strong>Fornecedor:</strong> #{cotacao.COT_FOR_ID}</div>
                    <div className="card-info"><strong>Valor Total:</strong> R$ {cotacao.item_cotacao?.reduce((acc, item) => acc + Number(item.IC_VALOR || 0) * Number(item.item?.IT_QUANTIDADE || 1), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                    <div className="card-info"><strong>Data de Envio:</strong> {cotacao.COT_DATA_VINCULACAO ? new Date(cotacao.COT_DATA_VINCULACAO).toLocaleDateString('pt-BR') : '-'}</div>
                    <div className="card-info"><strong>Status:</strong> {cotacao.COT_STATUS}</div>
                    <div className="card-info"><strong>Quantidade de Itens:</strong> {cotacao.item_cotacao?.length || '-'}</div>
                    <button
                      className="ver-cotacao-btn"
                      onClick={() => navigate(`/adm/cotacao/${cotacao.COT_ID}/aprovar`)}
                    >
                      Ver Cotação
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">Nenhuma cotação encontrada</div>
            )}
          </div>
          <div className="pagination">
            {cotacoesPaginacao?.prev_page_url && (
              <button className="pagination-btn" onClick={prevPage}>
                Voltar
              </button>
            )}
            <span className="pagination-info">
              Página {cotacoesPaginacao?.current_page || 1} de {cotacoesPaginacao?.last_page || 1}
            </span>
            {cotacoesPaginacao?.next_page_url && (
              <button className="pagination-btn" onClick={nextPage}>
                Próximo
              </button>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
            <button 
              onClick={() => navigate(-1)}
              style={{
                padding: '10px 32px',
                backgroundColor: '#001f4d',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600',
                boxShadow: '0 1px 3px rgba(0,31,77,0.08)'
              }}
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
      <ViewSolicitacaoModal
        isVisible={isModalOpen}
        onClose={handleCloseModal}
        solicitacao={selectedSolicitacao}
      />
    </div>
  );
};

export default Cotacao; 